import {Dispatcher} from 'flux';

import {MessageAction} from 'AppAction';

var dispatcher = new Dispatcher();

dispatcher.dispatchAlertWithAction = function(msgText, msgType, msgAction, actionData) {
		dispatcher.dispatch({
			type: MessageAction.MESSAGE_WITH_ACTION,
			message: {'message': msgText, 'type': msgType, 'alertAction': msgAction, 'actionData': actionData}
		});
	};

dispatcher.dispatchAnAlert = function(message) {
		dispatcher.dispatch({
			type: MessageAction.MESSAGE,
			message: message
		});
	};

dispatcher.dispatchClearAlert = function () {
		dispatcher.dispatch({
			type: MessageAction.CLEAR_MESSAGE
		});
	};

export default dispatcher;


// WEBPACK FOOTER //
// ./src/service/Dispatcher.js